var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, bindable } from "aurelia-framework";
import { transient } from "aurelia-dependency-injection";
import { CacheLocation, CacheClient } from "../../../services/basics/client-caching.service";
import * as Enumerable from "linq";
import { BindingSignaler } from "aurelia-templating-resources";
var Tabs = /** @class */ (function () {
    function Tabs(cacheClient, element, bindingSignaler) {
        this.cacheClient = cacheClient;
        this.element = element;
        this.bindingSignaler = bindingSignaler;
        this.checkErrorsFrequency = 500;
        this.cacheLastVisitedTab = true;
        this.removeLastVisitedTabCache = true;
        this.currentStepKey = "currentStep";
        this.titleKey = "title";
    }
    Tabs.prototype.titleKeyChanged = function () {
        var _this = this;
        setTimeout(function () {
            _this.bindingSignaler.signal('update-title');
        });
    };
    Tabs.prototype.tabsChanged = function () {
        var _this = this;
        if (this.currentTab) {
            this.currentTab = this.tabs.filter(function (x) { return x[_this.titleKey] == _this.currentTab[_this.titleKey]; })[0];
        }
        this.setTab();
        setTimeout(function () {
            _this.bindingSignaler.signal('update-title');
        });
    };
    Tabs.prototype.title = function (tab) {
        return typeof (tab[this.titleKey]) == "function" ? tab[this.titleKey]() : (tab[this.titleKey] ? tab[this.titleKey] : (typeof tab == "string" ? tab : ''));
    };
    Tabs.prototype.getShow = function (tab) {
        return "show" in tab ? (typeof (tab.show) == "function" ? tab.show() : tab.show) : true;
    };
    Tabs.prototype.bind = function () {
        this.titleKeyChanged();
        this.tabsChanged();
    };
    Tabs.prototype.goToTab = function (event, tab) {
        var _this = this;
        event.stopPropagation();
        if (tab.onClick) {
            tab.onClick(this);
        }
        if (this.currentTab !== tab) {
            this.currentTab = tab;
            if (this.cacheLastVisitedTab) {
                this.cacheClient.put(this.currentStepKey, this.currentTab.step, CacheLocation.LocalStorage);
            }
            setTimeout(function () {
                _this.element.dispatchEvent(new CustomEvent("tab-changed", {
                    bubbles: true,
                    detail: _this.currentTab
                }));
            });
        }
    };
    Tabs.prototype.setTab = function () {
        var _this = this;
        if (this.cacheLastVisitedTab) {
            this.cacheClient.get(this.currentStepKey, CacheLocation.LocalStorage).then(function (step) {
                if (!_this.currentTab) {
                    if (step)
                        _this.currentTab = Enumerable.from(_this.tabs).firstOrDefault(function (x) { return _this.getShow(x) && x.step == step; });
                    if (!_this.currentTab)
                        _this.currentTab = Enumerable.from(_this.tabs).firstOrDefault(function (x) { return _this.getShow(x); });
                }
            });
        }
    };
    Tabs.prototype.detached = function () {
        if (this.removeLastVisitedTabCache) {
            this.cacheClient.remove(this.currentStepKey, CacheLocation.LocalStorage);
        }
    };
    Tabs.prototype.getErrorCount = function (tab) {
        if (tab.element) {
            return $(tab.element).find(".error-validation").length;
        }
        if (tab.errorsCount > 0) {
            return tab.errorsCount;
        }
        return 0;
    };
    __decorate([
        bindable,
        __metadata("design:type", Array)
    ], Tabs.prototype, "tabs", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Number)
    ], Tabs.prototype, "checkErrorsFrequency", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Object)
    ], Tabs.prototype, "currentTab", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], Tabs.prototype, "cacheLastVisitedTab", void 0);
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], Tabs.prototype, "removeLastVisitedTabCache", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], Tabs.prototype, "currentStepKey", void 0);
    __decorate([
        bindable,
        __metadata("design:type", String)
    ], Tabs.prototype, "titleKey", void 0);
    Tabs = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [CacheClient, Element, BindingSignaler])
    ], Tabs);
    return Tabs;
}());
export { Tabs };
